module.exports = __webpack_public_path__ + "img/Map-Marker.65c366f5.svg";